<template>
  <div class="products-item">
    <div
      class="product-icon"
      :class="{ 'game-icon': gameId === '20195' }"
      :style="{
        backgroundImage: `url(${packageIconSrc})`,
      }"
    ></div>
    <!-- 
      {
        isOnlyBuy: true, - 游戏拉起 webshop 直接购买礼包标识字段
        package: {
          outer_package_name: 'Outer Package Name',
        },
      }
      分情况展示礼包内容
      1. 礼包主内容
        1. 存在
          1.1 常规礼包展示 名称+icon+数量
          1.2 直购礼包展示 icon+数量
        2. 不存在
          2.1 展示 outer_package_name
      2. 加赠内容
        1. 存在
          1.1 常规礼包展示 名称+icon+数量
          1.2 直购礼包展示 icon+数量
        2. 不存在
          2.1 不展示
    -->
    <div class="product-info">
      <div class="top">
        <p class="pack_name medium">
          <template v-if="pack.package.main_number > 0">
            <template v-if="!isWosOrKingshotGameId">
              <span class="hide-da" v-if="!pack.isOnlyBuy">{{
                $t(`card.logo_${$store.state.app.gameId}`)
              }}</span>
              <img class="item_pic" :src="pack.package.main_content" />
              <span>{{ pack.package.main_number | formatPrice }}</span>
            </template>
            <!-- gof、got第一行 -->
            <template v-else>
              <span
                class="hide-da"
                v-if="
                  !pack.isOnlyBuy &&
                  Number(pack.customization_flag) != 1 &&
                  Number(pack.customization_flag) != 2
                "
                >{{ $t(`card.logo_${$store.state.app.gameId}`) }}</span
              >
              <!-- 战斗框 -->
              <span
                class="hide-da"
                v-if="
                  !pack.isOnlyBuy &&
                  (Number(pack.customization_flag) == 1 || Number(pack.customization_flag) == 2)
                "
              >
                {{ pack.package.package_display_name }}
              </span>
              <img
                v-if="Number(pack.customization_flag) != 1 && Number(pack.customization_flag) != 2"
                class="item_pic"
                :src="pack.package.main_content"
              />
              <span
                v-if="Number(pack.customization_flag) != 1 && Number(pack.customization_flag) != 2"
                >{{ pack.package.main_number | formatPrice }}</span
              >
            </template>
          </template>
          <template v-else-if="pack.isOnlyBuy">
            <div class="pack_name_outer">{{ pack.package.outer_package_name }}</div>
          </template>
          <template v-else-if="gameId === '20195'">
            <div class="pack_name_outer">{{ pack.package.package_display_name }}</div>
          </template>
        </p>

        <!-- gof、got第二行 -->
        <template v-if="isWosOrKingshotGameId">
          <div v-if="pack.package.customization_flag == 1 || pack.package.customization_flag == 2">
            <p
              class="pack_name"
              :class="{ 'pack_gift regular': !pack.isOnlyBuy }"
              v-if="(pack.package.main_content || pack.package.items?.[0]) && isFirstOrCommon"
            >
              <!-- <span v-if="!pack.isOnlyBuy">{{ $t('game.extraGift') }}</span> -->
              <img class="item_pic" :src="pack.package.main_content" />
              <span>{{ pack.package.main_number | formatPrice }}</span>
              <span v-if="pack.package.items?.[0]?.item_number" class="plus">+</span>
              <img class="item_pic" :src="pack.package.items?.[0]?.icon" />
              <span>{{ pack.package.items?.[0]?.item_number.toLocaleString() }}</span>
            </p>
          </div>
          <div v-else>
            <p
              class="pack_name"
              :class="{ 'pack_gift regular': !pack.isOnlyBuy }"
              v-if="pack.package.items?.[0] && isFirstOrCommon"
            >
              <span v-if="!pack.isOnlyBuy">{{ $t('game.extraGift') }}</span>
              <img class="item_pic" :src="pack.package.items?.[0]?.icon" />
              <span>{{ pack?.package?.items?.[0].item_number.toLocaleString() }}</span>
            </p>
          </div>
        </template>
        <template v-else>
          <p
            class="pack_name"
            :class="{ 'pack_gift regular': !pack.isOnlyBuy }"
            v-if="pack.package.other_content?.[0] && isFirstOrCommon"
          >
            <span v-if="!pack.isOnlyBuy">{{ $t('game.extraGift') }}</span>
            <img class="item_pic" :src="pack.package.other_content?.[0].content" />
            <span>{{ pack.package.other_content[0].count.toLocaleString() }}</span>
          </p>
        </template>
      </div>

      <p class="pack_name pack_price medium">
        <span class="price">
          {{ pack.package.currency_label }} {{ pack.package.final_amount | formatPrice }}
        </span>
        <span>X1</span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import导入组件工具等
export default {
  props: {
    pack: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      gameConfig: (state) => state.config.gameConfig,
      isFirst: (state) => state.user.isFirst,
      gameId: (state) => state.app.gameId,
    }),
    isFirstOrCommon() {
      return this.pack.package_type !== 3 || this.isFirst
    },
    /** wos(20121/20317) / kingshot(20235/20349) 构建 */
    isWosOrKingshotGameId() {
      const gid = process.env.VUE_APP_GAME_ID
      return (
        gid === '20235' || gid === '20121' || gid === '20317' || gid === '20349' || gid === '20343'
      )
    },
    packageIconSrc() {
      const p = (this.pack && this.pack.package) || {}
      if (
        this.gameId === '20235' ||
        this.gameId === '20121' ||
        this.gameId === '20317' ||
        this.gameId === '20349' ||
        this.gameId === '20343'
      ) {
        return p.package_pic || p.icon
      } else if (this.gameId === '20195') {
        return this.gameConfig.icon
      }
      return p.package_pic || ''
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.products-item {
  display: flex;
  align-items: stretch;
  justify-content: center;
  & + .products-item {
    margin-top: 8px;
  }
  .product-icon {
    width: 92px;
    padding-top: calc(92px / 1.4737);
    border-radius: 8px;
    overflow: hidden;
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-right: 8px;
    flex-shrink: 0;
  }
  .product-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
  }

  .pack_name {
    font-size: 14px;
    color: #202226;
    line-height: 18px;
    display: flex;
    align-items: center;
    .item_pic {
      width: auto;
      height: 18px;
      margin: 0px 3px;
    }
    .item_pic:first-child {
      margin-left: 0;
    }
  }

  .pack_gift {
    color: #62676b;
    font-size: 13px;
    line-height: 16px;
  }

  .pack_price {
    color: #343a3f;
    display: flex;
    justify-content: space-between;
  }
  .pack_name_outer {
    line-height: 14px;
    max-height: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .plus {
    font-weight: 700;
    font-size: 17px;
    margin-left: 5px;
    color: grey;
  }
}
</style>
